import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { setModal } from "../Redux/uiSlice";
import { InteractionScreen } from "../Redux/screenInteractionsSlice";

export type KeyEvent = 'kd' | 'ku';

export const useKeyboardEventListener = (deps: Array<any> = []) => {

    const { modal, screen } = useAppSelector(s => ({
        modal: s.ui.modal,
        screen: s.screenInteractions.screen
    }));

    const dispatch = useAppDispatch();

    const handleKey = (e: KeyboardEvent) => {
        if (screen !== InteractionScreen.GAME && screen !== InteractionScreen.SANDBOX && e.repeat) return;

        const eventType = e.type === 'keyup' ? 'ku' : 'kd';

        if (modal) {
            if (e.code === 'Escape') {
                dispatch(setModal());
            }
            return;
        }
        switch (e.code) {
            case 'ArrowUp':
                window.postMessage({ wowboi: true, event: eventType, button: 'up' })
                break;
            case 'ArrowRight':
                window.postMessage({ wowboi: true, event: eventType, button: 'right' })
                break;
            case 'ArrowDown':
                window.postMessage({ wowboi: true, event: eventType, button: 'down' })
                break;
            case 'ArrowLeft':
                window.postMessage({ wowboi: true, event: eventType, button: 'left' })
                break;
            case 'KeyX':
                window.postMessage({ wowboi: true, event: eventType, button: 'x' })
                break;
            case 'KeyZ':
                window.postMessage({ wowboi: true, event: eventType, button: 'z' })
                break;
            case 'Space':
            case 'Enter':
                window.postMessage({ wowboi: true, event: eventType, button: 'start' })
                break;
            case 'Escape':
                window.postMessage({ wowboi: true, event: eventType, button: 'home' })
                break;
            default:
                return;
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKey);
        if (screen === InteractionScreen.GAME || screen === InteractionScreen.SANDBOX) {
            window.addEventListener('keyup', handleKey);
        }

        return () => {
            window.removeEventListener('keydown', handleKey);
            if (screen === InteractionScreen.GAME || screen === InteractionScreen.SANDBOX) {
                window.removeEventListener('keyup', handleKey);
            }
        }
    }, [...deps]);

}